export default __webpack_public_path__ + "static/media/logo-crm.693f838f.png";